import React from "react";
import SectionTitle from "../../components/layouts/others/title-section.layout";
import {Container, Box, Typography, Divider, Paper, Stack, Chip, Avatar} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLeaf, faBalanceScale, faUsers, faCheckCircle, faHandshake, faLightbulb } from "@fortawesome/free-solid-svg-icons";
import { faHeart } from "@fortawesome/free-regular-svg-icons";
// @ts-ignore
import photoJpg from "../../assets/images/others/jpg.png"

const POST20250615: React.FC = () => {
    return (
        <Container sx={{ mb: 5 }}>
            <SectionTitle title="ESPACE INFORMATIONS DES HABITANTS" />
            <Box mt={3} mb={3}>
                <Typography
                    variant="h6"
                    fontWeight={700}
                    align="center"
                    gutterBottom
                    color="primary"
                >
                    <FontAwesomeIcon icon={faLeaf} style={{ marginRight: 8 }} />
                    VLD2026 - Tract 1 du 15&nbsp;juin&nbsp;2025
                </Typography>
                <Divider sx={{ mt: 1, mb: 3 }} />
            </Box>

            <Paper elevation={3} sx={{ p: 4, mb: 4, borderRadius: 4, background: "linear-gradient(100deg,#edf4fa 60%, #f6fcff 100%)" }}>
                <Typography variant="body1" paragraph>
                    <strong>
                        Bois-le-Roi est notre bien commun, un endroit unique avec un riche patrimoine naturel
                        et artistique de Village d’Art, et une qualité de vie exceptionnelle mais fragile, où il fait bon vivre.
                    </strong>
                </Typography>
                <Typography variant="body1" paragraph>
                    Aujourd’hui, <strong>les caisses sont vides</strong>, les ressources ont été gaspillées et la commune est durablement <strong>surendettée</strong>.
                    La majorité sortante n'a eu aucun scrupule à taxer les Bacots pour financer sa gestion autocratique et son échec.
                    Elle n'a pas eu non plus de scrupule à vouloir spolier les propriétaires des Secteurs de Mixité Sociale de son PLUi.
                </Typography>
                <Typography variant="body1" paragraph color="primary" fontWeight={600}>
                    La transformation pour rendre possible le Bois-le-Roi de demain passe par une rupture complète avec les pratiques dispendieuses et anti-démocratiques de la majorité sortante, qui n’arrive plus à maîtriser le désastre qu’elle a elle-même créé.
                </Typography>
                <Typography variant="h6" color="secondary" align="center" fontWeight={700} sx={{ mt: 2 }}>
                    <FontAwesomeIcon icon={faLightbulb} style={{ marginRight: 8, color: "#fbc02d" }} />
                    2026 doit impérativement être l'année du sursaut pour Bois-le-Roi
                </Typography>
                <Typography variant="body1" mt={2}>
                    C’est pourquoi, j'ai décidé de me présenter aux élections municipales de 2026 avec la liste <strong>Vivre la démocratie (VLD)</strong>.
                </Typography>
                <Typography variant="body1" mt={2}>
                    <strong>Sans étiquette politique</strong>, la liste VLD rassemble des compétences et des profils divers autour de solides valeurs communes, dont l’esprit démocratique dans lequel nous entendons inscrire notre action, en
                    replaçant l'humain au cœur de nos préoccupations, afin de servir et de protéger la qualité de vie et les intérêts de tous les Bacots.
                </Typography>
            </Paper>

            <Box mb={3}>
                <Paper elevation={1} sx={{ p: 3, borderRadius: 4, background: "#fffef8" }}>
                    <Typography variant="subtitle1" fontWeight={700} mb={1} align="center">
                        <FontAwesomeIcon icon={faUsers} style={{ color: "#0288d1", marginRight: 6 }} />
                        Vos attentes sont légitimes.
                    </Typography>
                    <Typography variant="body2" mb={1}>
                        Vous aspirez à plus de transparence, à un véritable contrôle citoyen, et à des élus qui vous écoutent vraiment&nbsp;?
                    </Typography>
                    <Typography variant="body2" mb={1}>
                        Vous exigez une gestion rigoureuse des finances communales, un service public de qualité, et des décisions prises dans l’intérêt général, avec honnêteté et respect&nbsp;?
                    </Typography>
                </Paper>
            </Box>

            <Stack direction={{ xs: 'column', md: 'row' }} spacing={3} mb={4} divider={<Divider flexItem />}>
                <Box flex={1}>
                    <Chip icon={<FontAwesomeIcon icon={faCheckCircle} style={{ color: "#FFFFFF" }} />} label="Redonner des perspectives" color="success" sx={{ mb: 2, fontSize: '1.1rem', fontWeight: 600 }} />
                    <Typography variant="body2" mb={1}>
                        <FontAwesomeIcon icon={faBalanceScale} style={{ color: "#1565c0", marginRight: 8 }} />
                        Redresser les finances tout en desserrant l’étau fiscal,
                        établir un plan d'investissement pluriannuel sur 10&nbsp;ans
                        et une stratégie face à l'obligation SRU.
                    </Typography>
                </Box>
                <Box flex={1}>
                    <Chip icon={<FontAwesomeIcon icon={faLeaf} style={{ color: "#FFFFFF" }} />} label="Préserver notre qualité de vie" color="primary" sx={{ mb: 2, fontSize: '1.1rem', fontWeight: 600 }} />
                    <Typography variant="body2" mb={1}>
                        <FontAwesomeIcon icon={faHeart} style={{ color: "#e57373", marginRight: 8 }} />
                        Améliorer le service rendu aux habitants, protéger et valoriser notre patrimoine naturel exceptionnel, conserver la physionomie actuelle de Bois-le-Roi et son riche passé historique et artistique.
                    </Typography>
                </Box>
                <Box flex={1}>
                    <Chip icon={<FontAwesomeIcon icon={faHandshake} style={{ color: "#FFFFFF" }} />} label="Respiration démocratique" color="warning" sx={{ mb: 2, fontSize: '1.1rem', fontWeight: 600 }} />
                    <Typography variant="body2" mb={1}>
                        <FontAwesomeIcon icon={faUsers} style={{ color: "#0288d1", marginRight: 8 }} />
                        Vous écouter, partager les informations, vous associer au processus de décisions politiques, trouver les consensus nécessaires pour avancer dans l'intérêt général, et vous rendre compte.
                    </Typography>
                </Box>
            </Stack>

            <Paper elevation={2} sx={{ p: 3, borderRadius: 3, background: "#edf7fa", mb: 4 }}>
                <Typography variant="h6" align="center" color="primary" fontWeight={700} mb={1}>
                    <FontAwesomeIcon icon={faHeart} style={{ marginRight: 8 }} />
                    Vous aimez Bois-le-Roi&nbsp;?
                </Typography>
                <Typography variant="body2" align="center" mb={2}>
                    Vous voulez que Bois-le-Roi reste cette commune où il fait bon vivre&nbsp;?
                </Typography>
                <Typography variant="body2" align="center" mb={2}>
                    Soutenez le changement de politique que je vous propose pour préserver notre belle commune et son riche patrimoine matériel et immatériel,
                    pour rétablir le lien de confiance et de respect mutuel avec vos élus, et défendre les intérêts de tous les Bacots sans distinction.<br />
                    <strong>Nous avons une responsabilité particulière, rejoignez-nous.</strong>
                </Typography>
                <Box display="flex" justifyContent={"center"} alignItems="center" mt={3} mb={3}>
                    <Avatar
                        src={photoJpg}
                        alt="Photo de Jean-Philippe GUIBERT"
                        sx={{
                            width: 192,
                            height: 192,
                            boxShadow: "0px 4px 18px rgba(0,0,0,0.18)",
                        }}
                    />
                </Box>
                <Typography variant="subtitle1" align="center" fontWeight={700}>
                    Jean-Philippe Guibert
                </Typography>
            </Paper>

            <Paper elevation={0} sx={{ p: 2, borderLeft: "5px solid #00838f", background: "#f1f8e9" }}>
                <Typography variant="subtitle2" fontWeight={700} mb={1}>
                    Qui suis-je ?
                </Typography>
                <Typography variant="body2">
                    Âgé de 59 ans, je suis marié et père de 3 filles. De formation scientifique, je suis photographe bacot depuis 26 ans durant lesquels j’ai activement contribué à mettre en valeur le patrimoine naturel, historique et artistique du Pays de Fontainebleau, et de Bois-le-Roi en particulier.
                </Typography>
                <Typography variant="body2" mt={1} mb={1}>
                    Je me suis beaucoup investi dans ma mission d’adjoint aux affaires scolaires et périscolaires, notamment lors de la pandémie du Covid où j’ai fait le nécessaire pour accueillir dans les meilleures conditions les enfants des personnels mobilisés puis rouvrir le plus grand nombre de classes en primaire. J’ai attendu la fin de l’année scolaire pour démissionner, en juin 2020.
                </Typography>
                <Typography variant="body2">
                    La démocratie participative, je l'ai pratiquée durant mon mandat, et cela donne des résultats !
                </Typography>
            </Paper>
        </Container>
    );
};

export default POST20250615;